import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData } from '../../apiService';
import {
  Card,
  CardContent,
  IconButton,
  CircularProgress,
} from '@mui/material';
import ArrowForward from '@mui/icons-material/ArrowForward';
import RestaurantMenu from '@mui/icons-material/Restaurant';
import { Link } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import TableRestaurantIcon from '@mui/icons-material/TableRestaurant';

const Home = () => {
  const { isAuthenticated, companyId, permissions, token, logout } = useAuth();
  const hasCreateTransactionPermission = permissions && permissions.includes('Create Transaction');

  const { id } = useParams();
  const history = useHistory();
  const [freedata, setFreeData] = useState([]);
  const [occupieddata, setOccupiedData] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state

  useEffect(() => {
    let intervalId;

    if (isAuthenticated) {
      fetchAllData(); // Fetch data immediately when the component mounts

      // Set up an interval t o fetch data every 30 seconds
      intervalId = setInterval(() => {
        fetchAllData();
      }, 30000); // 30 seconds
    }

    // Cleanup the interval when the component unmounts or dependencies change
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [isAuthenticated, companyId, token, logout, id]);

  const fetchAllData = async () => {
    setLoading(true); // Set loading to true when fetching starts
    try {
      await Promise.all([fetchItemData(), fetchTableData()]);
    } finally {
      setLoading(false); // Set loading to false when fetching completes
    }
  };

  const fetchItemData = async () => {
    try {
      setFreeData([]);
      const response = await fetchData('TableNameApi', `/FreeTable/${companyId}`, token);
      if (response.responseCode === '1111') {
        setFreeData(response.response_data);
      }
    } catch (error) {
      console.error('Error fetching Table Data', error);
    }
  };

  const fetchTableData = async () => {
    try {
      setOccupiedData([]);
      const response = await fetchData('TableNameApi', `/OccupiedTable/${companyId}`, token);
      if (response.responseCode === '1111') {
        setOccupiedData(response.response_data);
      }
    } catch (error) {
      console.error('Error fetching Table Data', error);
    }
  };

  const getTimeDuration = (kotTime) => {
    const currentTime = new Date();
    const [hours, minutes, seconds] = kotTime.split(':');
    const kotDate = new Date();
    kotDate.setHours(hours, minutes, seconds.split('.')[0]);

    const diffInMs = currentTime - kotDate;
    if (diffInMs < 0) {
      return 'Time not valid';
    }

    const diffInMinutes = Math.floor(diffInMs / 60000);
    const hoursDiff = Math.floor(diffInMinutes / 60);
    const minutesDiff = diffInMinutes % 60;

    return hoursDiff > 0 ? `${hoursDiff}h ${minutesDiff}m` : `${minutesDiff}m`;
  };

  return (
    <div
      className="container w-full max-w-sm container mt-2 mx-auto"
      style={{ maxHeight: '730px', overflow: 'auto' }}
    >
      <style>
        {`
          /* Hide scrollbar for Chrome, Safari, and Opera */
          .container::-webkit-scrollbar {
            width: 0.1em;
          }
  
          .container::-webkit-scrollbar-track {
            background: rgba(255,255,255,0);
          }
  
          .container::-webkit-scrollbar-thumb {
            background-color: rgba(255,255,255,0);
            border-radius: 4px;
          }
        `}
      </style>
      {loading ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <div className="flex flex-wrap justify-between" style={{ maxHeight: '800px' }}>
          <Card
            className="w-full sm:w-3/4 mb-4 rounded-lg shadow-lg"
            style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}
          >
            <CardContent>
              <div>
                <h4
                  className="block uppercase text-lg font-semibold mb-4 linkcolor mr-2"
                  style={{
                    fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',
                    color: 'black',
                  }}
                >
                  Occupied Tables
                </h4>
              </div>
              <div className="w-full mb-5" style={{ display: 'flex', flexWrap: 'wrap' }}>
                {occupieddata &&
                  occupieddata.map((item) => (
                    <Card
                      key={item.Id}
                      className="customCard"
                      style={{
                        marginBottom: '10px',
                        background: 'linear-gradient(to right, #091057,red)',
                        color: 'white',
                        marginLeft: '30px',
                        height: '110px',
                        boxSizing: 'border-box',
                      }}
                    >
                      <CardContent
                        style={{
                          height: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                          alignItems: 'left',
                          padding: '7px',
                          boxSizing: 'border-box',
                        }}
                      >
                        <div
                          style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            textAlign: 'left',
                          }}
                        >
                          <TableRestaurantIcon /> {item.Name}
                        </div>
                        <div
                          style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            fontSize: '12px',
                            textAlign: 'left',
                            marginTop: '5px',
                          }}
                        >
                          Order No: {item.KotNo}
                          <p>{getTimeDuration(item.KOTTime)}</p>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <div style={{ marginLeft: '5px', fontSize: '12px' }}>More Info</div>
                          {hasCreateTransactionPermission && (
                            <Link to={`/kotEdit/${item.KotId}`}>
                              <IconButton>
                                <ArrowForward style={{ color: 'whitesmoke' }} />
                              </IconButton>
                            </Link>
                          )}
                        </div>
                      </CardContent>
                    </Card>
                  ))}
              </div>
            </CardContent>
          </Card>

          <Card
            className="w-full sm:w-1/5 mb-4 rounded-lg shadow-lg"
            style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}
          >
            <CardContent>
              <div>
                <h4
                  className="block uppercase text-lg font-semibold mb-4 linkcolor mr-2"
                  style={{
                    fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',
                    color: 'black',
                  }}
                >
                  Free Tables
                </h4>
              </div>
              <div className="w-full mb-5" style={{ display: 'flex', flexWrap: 'wrap' }}>
                {freedata &&
                  freedata.map((item) => (
                    <Card
                      key={item.Id}
                      className="customCard"
                      style={{
                        marginBottom: '10px',
                        background: 'linear-gradient(to right, #28A745,#1A5319)',
                        color: 'white',
                      }}
                    >
                      <CardContent
                        style={{
                          height: '40px',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        <RestaurantMenu />
                        <div style={{ height: '40px', width: '450px', padding: '10px' }}>
                          {item.Name}
                        </div>
                        {hasCreateTransactionPermission && (
                          <Link to={`/kotCreate/${item.Id}`}>
                            <IconButton>
                              <ArrowForward style={{ color: 'whitesmoke' }} />
                            </IconButton>
                          </Link>
                        )}
                      </CardContent>
                    </Card>
                  ))}
              </div>
            </CardContent>
          </Card>
        </div>
      )}
    </div>
  );

};

export default Home;
